import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { TransportEventsTable } from "@/components/stock/transport-events-table";
import { useTransportOrderEvents } from "@/hooks/use-transport-order-events";

/** Props Interface */
interface TransportOrderEventsModalProps extends ModalProps {
	transportOrderId: string;
}

/**
 * One leg's chain of custody, opened from the transport list's row actions.
 *
 * It exists because the row itself cannot tell the truth about a handover: `pickedUpBy` is
 * overwritten when a carry changes hands, so the table shows whoever holds the box now and the
 * driver who fetched it is only in here.
 */
export function TransportOrderEventsModal({
	isOpen,
	onClose,
	transportOrderId,
}: TransportOrderEventsModalProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { events, isLoading, refetch, queryKey } = useTransportOrderEvents(transportOrderId);

	/** Render */
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t("stock.transport_event_history")}
			width="80vw"
		>
			<Modal.Body>
				<Modal.TableWrapper>
					<TransportEventsTable
						events={events}
						isLoading={isLoading}
						refetch={refetch}
						queryKey={queryKey}
						persistenceKey="transport-order-events-table"
						withCarrier={false}
					/>
				</Modal.TableWrapper>
			</Modal.Body>
		</Modal>
	);
}
